module.exports = __webpack_public_path__ + "img/appAsset--alerts-ax.44d437fa.svg";